export class TranslationService {
    translations = {};
    currentLanguage = 'pt-BR';
    constructor(translations = {}, defaultLanguage = 'pt-BR') {
        this.translations = translations;
        this.currentLanguage = defaultLanguage;
    }
    loadTranslations(translations) {
        const mergedTranslations = { ...this.translations };
        for (const [language, dictionary] of Object.entries(translations)) {
            if (dictionary) {
                mergedTranslations[language] = {
                    ...mergedTranslations[language],
                    ...dictionary,
                };
            }
        }
        this.translations = mergedTranslations;
    }
    setLanguage(language) {
        this.currentLanguage = language;
    }
    getCurrentLanguage() {
        return this.currentLanguage;
    }
    getAvailableLanguages() {
        return Object.keys(this.translations);
    }
    translate(key, variables) {
        const translation = this.getTranslation(key);
        if (!variables) {
            return translation;
        }
        return this.interpolateVariables(translation, variables);
    }
    getTranslation(key) {
        const languageDict = this.translations[this.currentLanguage];
        if (!languageDict) {
            console.warn(`No translations found for language: ${this.currentLanguage}`);
            return key;
        }
        const translation = languageDict[key];
        if (!translation) {
            console.warn(`Translation not found for key: ${key} in language: ${this.currentLanguage}`);
            return key;
        }
        return translation;
    }
    interpolateVariables(translation, variables) {
        return translation.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
            const value = variables[variableName];
            return value !== undefined ? String(value) : match;
        });
    }
}
